import { render, staticRenderFns } from "./AvPopper.vue?vue&type=template&id=8baf2348&lang=pug"
import script from "./AvPopper.vue?vue&type=script&lang=js"
export * from "./AvPopper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports